/* ============================================================
   sm-hn-samantekt.js
   Samantekt a valinu i kaupareit husnumerasidunnar, eins og
   hurdaskiltastikan hefur: "Akryl gull · 7,5 × 12 cm · Nutimalegt · Rammi".

   Husnumerasidan hafdi adeins almenn loford i sinum reit ("Fri
   heimsending", "3-5 virkir dagar"), ekki hvad thu ert buinn ad velja.
   Gildin eru thegar til i DOM-inu: hvert skref ber .hn-val med valinu
   sinu, sett af sm-husnumer.js.

   ATH um siuna: skref 5 (Gotuheiti) ber stafateljara i .hn-val, t.d.
   "11/24", sem a ekkert erindi i samantekt. Hann er sidadur ut a forminu
   toluskastrikatala, ekki a staerd skrefsins, svo rodin ma breytast.
   Tom gildi (t.d. Festing adur en valid er) falla lika ut.
   ============================================================ */
(function () {
  var chk = document.querySelector('.pdp-hn .hn-checkout');
  if (!chk) return;

  var lina = chk.querySelector('.hn-samantekt');
  if (!lina) {
    lina = document.createElement('div');
    lina.className = 'hn-samantekt';
    chk.insertBefore(lina, chk.firstChild);
  }

  var teljari = /^\s*\d+\s*\/\s*\d+\s*$/;

  function uppfaera() {
    var gildi = [];
    var val = document.querySelectorAll('.pdp-hn .hn-val');
    for (var i = 0; i < val.length; i++) {
      var t = (val[i].textContent || '').trim();
      if (!t || teljari.test(t)) continue;
      gildi.push(t);
    }
    var texti = gildi.join(' · ');
    /* Adeins skrifad thegar thad breytist, annars vekur athugandinn
       sjalfan sig endalaust. */
    if (lina.textContent !== texti) lina.textContent = texti;
  }

  uppfaera();

  var raetur = chk.closest('form') || document.querySelector('.pdp-hn');
  if (raetur && window.MutationObserver) {
    new MutationObserver(uppfaera).observe(raetur, {
      subtree: true, childList: true, characterData: true
    });
  }
})();
